import { Component } from '@angular/core';
import { VehicleRetailMarketStatsComponent } from '../vehicle-retail-market-stats';

@Component({
  selector: 'vpfa-vehicle-retail-market-stats-mobile',
  templateUrl: './vehicle-retail-market-stats-mobile.component.html',
  styleUrls: ['./vehicle-retail-market-stats-mobile.component.scss'],
})
export class VehicleRetailMarketStatsMobileComponent extends VehicleRetailMarketStatsComponent {}
